import { useState, useCallback, useEffect } from "react";
import axiosInstance from "../config/axiosApi/axiosApi";
import APIs from "../Constants/apis";
import showErrorToast from "../components/CustomComponents/toast/toast";

/**
 * Shared hook to fetch currencies from GET_ALL_CURRENCIES API.
 * Used by Profile and Purchase Order Payments (Add Payment modal) so both show the same currency options.
 * @returns {{ currencies: Array<{value: string, text: string}>, loading: boolean, refetch: function }}
 */
const useCurrencies = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCurrencies = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_ALL_CURRENCIES);
      const data = response.data?.data;
      setCurrencies(Array.isArray(data) ? data : []);
    } catch (err) {
      showErrorToast("Failed to load currencies");
      setCurrencies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCurrencies();
  }, [fetchCurrencies]);

  return { currencies, loading, refetch: fetchCurrencies };
};

export default useCurrencies;
